<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="$resourceLoading()">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  <ng-container notifications>
    @if (this.$isDisabled()) {
      <unity-banner-alert-shared icon="infoSolidIcon">
        <div>This Vendor is in a 'Disabled' state.</div>
      </unity-banner-alert-shared>
    }
  </ng-container>

  <ng-container actions>
    <unity-workflow-selector-shared
      [transitions]="$availableTransitions()"
      [disabled]="$workflowActionsDisabled()"
      (workflowEvent)="onWorkflow($event)" />
    <unity-action-delete-shared
      *unityAuthorize="deleteEntitlement"
      [disabled]="$workflowActionsDisabled()"
      [buttonText]="`Delete ${resourceName}`"
      [confirmationTitle]="`Confirm Delete ${resourceName}?`"
      [confirmationMessage]="`Are you sure you want to delete this ${resourceName}?`"
      (deleteEvent)="onDelete()" />
    <unity-action-download-shared buttonText="Download W9 Form" [disabled]="$isDownloading()" (downloadEvent)="downloadW9File()" />
  </ng-container>

  @let formGroup = $formGroup();
  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="$isEntitledToEdit()"
    [submitLoading]="$updateLoading()"
    (saveEvent)="onSave()"
    (detailEditEvent)="toggleWorkflowActions($event)">
    <unity-form-layout>
      <unity-textbox-control displayName="Name" description="Provide a name." [control]="formGroup.controls.name" />
      <unity-dropdown-control
        displayName="Type"
        description="Choose the vendor type."
        [values]="$vendorTypes()"
        [control]="formGroup.controls.type_id" />
      <unity-textbox-control
        displayName="TIN"
        description="Enter the vendor's Taxpayer Identification Number (TIN)."
        [control]="formGroup.controls.tin" />
      @if (formGroup.enabled) {
        <unity-file-uploader-control
          displayName="Replace W9"
          description="Provide the vendor's W9 form (in PDF format)"
          [control]="formGroup.controls.w9_upload_id"
          [allowedExtensions]="['pdf']" />
      }
    </unity-form-layout>
  </unity-panel-manage-shared>
</unity-page-container>
